<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import ToolForm from './ToolForm.vue';

const props = defineProps({
  tool: { type: Object, default: () => ({}) },
  assistantId: { type: Number, default: null },
});

const emit = defineEmits(['close', 'submit']);
const { t } = useI18n();
const dialogRef = ref(null);

const isEdit = computed(() => Boolean(props.tool?.id));
const title = computed(() =>
  isEdit.value
    ? t('ARROWS_AI.TOOLS.EDIT_TITLE')
    : t('ARROWS_AI.TOOLS.CREATE_TITLE')
);

defineExpose({ dialogRef });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="edit"
    :title="title"
    :show-cancel-button="false"
    :show-confirm-button="false"
    overflow-y-auto
    @close="emit('close')"
  >
    <ToolForm
      :tool="tool"
      :assistant-id="assistantId"
      :submit-label="isEdit ? t('ARROWS_AI.UPDATE') : t('ARROWS_AI.CREATE')"
      @submit="emit('submit', $event)"
      @cancel="dialogRef.close()"
    />
    <template #footer />
  </Dialog>
</template>
